<template>
  <b-card
    class="news-details-video"
    no-body
  >
    <b-card-header class="border-bottom">
      <b-card-title class="font-weight-bold text-secondary font-medium-3">
        <span>{{ avData.title }}</span>
      </b-card-title>
    </b-card-header>
    <div class="mt-2 mb-2">
      <b-row class="match-height d-flex mx-1 font-medium-1 font-weight-bold text-dark">
        <b-col>
          {{ avData.labelTitle }}
        </b-col>
        <b-col>
          {{ avData.avgTimeTitle }}
        </b-col>
        <b-col>
          {{ avData.durationTitle }}
        </b-col>
        <b-col>
          {{ avData.playedTitle }}
        </b-col>
        <b-col>
          {{ avData.playedRatioTitle }}
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in avData.list"
        :key="`av-item-${index}`"
        class="match-height mx-1 mt-1 font-medium-1"
      >
        <b-col>
          {{ item.label }}
        </b-col>
        <b-col>
          {{ item.avgTimeDisplay }}
        </b-col>
        <b-col>
          {{ item.duration }}
        </b-col>
        <b-col>
          {{ item.played }}
        </b-col>
        <b-col>
          <b-progress
            v-b-tooltip.hover
            max="100"
            height="20px"
            variant="secondary"
            class="mb-1"
            :title="`${item.playedRatio}%`"
          >
            <b-progress-bar :value="item.playedRatio">
              <span><strong>{{ item.playedRatio }}%</strong></span>
            </b-progress-bar>
          </b-progress>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, BProgress, BProgressBar, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
        BProgress,
        BProgressBar,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        avData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
